import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PersonProjectDto, PersonProjectsFilter } from '../dtos/person-project-dto.interface';
import { ProjectStatus } from '../enums/project-status.enum';

/** REV-22155 — person projects. */
export const PersonProjectsActions = createActionGroup({
    source: 'Person Projects',
    events: {
        // Logout: no person projects of the previous user stay in the browser.
        'Reset Person Projects': emptyProps(),
        'Load Person Projects': props<{ filter?: PersonProjectsFilter }>(),
        'Person Projects Loaded': props<{ response: { personProjects: PersonProjectDto[]; totalCount: number } }>(),
        'Person Projects Load Failure': props<{ error: HttpErrorResponse }>(),

        'Load Person Project': props<{ projectId: string }>(),
        'Person Project Loaded': props<{ project: PersonProjectDto }>(),
        'Person Project Load Failure': props<{ error: HttpErrorResponse }>(),

        'Create Person Project': props<{ personId: string; year: number }>(),
        'Person Project Created': props<{ project: PersonProjectDto }>(),
        'Person Project Create Failure': props<{ error: HttpErrorResponse }>(),

        'Update Person Project Status': props<{
            projectId: string;
            status: ProjectStatus;
            updateTasks: boolean;
            mandateManagementTaskIds?: string[];
        }>(),
        'Person Project Status Updated': props<{ project: PersonProjectDto }>(),
        'Person Project Status Update Failure': props<{ error: HttpErrorResponse }>(),

        'Bulk Update Person Project Status': props<{
            projectIds: string[];
            status: ProjectStatus;
            updateTasks: boolean;
            mandateManagementTaskIds?: string[];
        }>(),
        'Bulk Person Project Status Updated': props<{ projects: PersonProjectDto[] }>(),
        'Bulk Update Person Project Status Failure': props<{ error: HttpErrorResponse }>(),

        'Delete Person Project': props<{ projectId: string }>(),
        'Person Project Deleted': props<{ projectId: string }>(),
        'Person Project Delete Failure': props<{ error: HttpErrorResponse }>(),

        'Bulk Delete Person Projects': props<{ projectIds: string[] }>(),
        'Bulk Person Projects Deleted': props<{ deletedIds: string[] }>(),
        'Bulk Delete Person Projects Failure': props<{ error: HttpErrorResponse }>(),

        'Set Active Person Project Id': props<{ projectId: string }>(),
        'Clear Active Person Project Id': emptyProps(),
    },
});
